import { Component } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { EventService } from 'src/app/services/event.service';



@Component({
  selector: 'app-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.scss']
})

export class RoadmapComponent {
  lang: any = localStorage.getItem('currentlang');
  activeSlides: any;
  curIndx: number = 0;
  activeTab: string = 'road2_title';


  constructor(private eventService: EventService) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
  }
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 767px)').matches) || screen.width <= 767
  slideOption: OwlOptions = {
    loop: false,
    autoplay: false,
    dots: true,
    margin: 0,
    center: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    // nav: true,
    // navText: [
    //   "<img src='/assets/images/icon-arrow-left.svg'>",
    //   "<img src='/assets/images/icon-arrow-right.svg'>",
    // ],
    responsive: {
      0: {
        items: 1.3,
        center: true,
        loop: false,
        dots: true,
        margin: -80,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        autoplay: false,
        smartSpeed: 400,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',


      },
      540: {
        items: 2,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        dots: false,
      },
      940: {
        items: 4,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        dots: false,
      },

      1200: {
        items: 6,
      }
    },
  };



  timeline: Array<any> = [
    {
      title: 'road1_title',

      // check: true,
      staking: '',
      data: [
        { title: 'road1_con1', pass: true },
        { title: 'road1_con2', pass: true },
        { title: 'road1_con3', pass: true },
        { title: 'road1_con5', pass: true },
        { title: 'road1_con6', pass: true },
        { title: 'road1_con8', pass: true },
      ],
    },
    {
      title: 'road2_title',
      // quarter:"road2_quarter",
      // check: true,
      staking: '',
      data: [
        { title: 'road2_con1', pass: true },
        { title: 'road2_con2', pass: true },
        { title: 'road2_con3', pass: true },
        { title: 'road2_con4', pass: false },
      ],
    },
    {
      title: 'road3_title',
      // quarter:"road3_quarter",
      staking: '',
      data: [
        { title: 'road3_con1', pass: false },
        { title: 'road3_con2', pass: false },
        { title: 'road4_con1', pass: false },
      ],
    },
    {
      title: 'road4_title',
      // quarter:"road4_quarter",
      staking: '',
      data: [
        { title: 'road4_con2', pass: false },
        { title: 'road3_con3', pass: false },
        { title: 'road3_con2', pass: false },
        { title: 'road3_con4', pass: false },
      ],
    },
    {
      title: 'road5_title',
      // quarter:"road5_quarter",
      // staking: 'road_staking',
      staking: '',
      data: [
        { title: 'road5_con1', pass: false },
        { title: 'road5_con2', pass: false },
        { title: 'road5_con3', pass: false },
      
      ],
    },
    {
      title: 'road6_title',
      // quarter:"road6_quarter",
      staking: '',
      data: [
        { title: 'road6_con1', pass: false },
        { title: 'road6_con3', pass: false },
        { title: 'road6_con4', pass: false },
        { title: 'road6_con5', pass: false },
        { title: 'road6_con6', pass: false },
        { title: 'road6_con7', pass: false },
        { title: 'road6_con8', pass: false },

      ],
    },
  ]
// addMarginTopClass(dataIndex: number, dataIndexToApplyMargin: number): boolean {
//   return dataIndex === dataIndexToApplyMargin;
// }

  // @HostListener('window:scroll', ['$event'])
  // checkScroll() {
  //   const halfScreen = window.innerHeight / 2;
  //   const elements = document.querySelectorAll('.active-ml');
  //   elements.forEach((item: any, i) => {
  //     const rect = item.getBoundingClientRect();
  //     const topPos = rect.top;
  //     if (topPos - 100 < halfScreen) {
  //       item.classList.add('active');
  //     } else {
  //       item.classList.remove('active');
  //     }
  //   })
  // }
  options: AnimationOptions = {
    path: '/assets/lottie/roadmap-avtar.json'
  };
  onAnimate(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
  styles: Partial<CSSStyleDeclaration> = {
    width: '165px',
    height: '165px',
    margin: '0 auto',
    scale: '1.8'
  };
  setActiveClass(title: string) {
    this.activeTab = title;
  }

  isTabActive(timelineItem: any) {
    return (timelineItem.title === this.activeTab || timelineItem.check)
  }

  getData(data: SlidesOutputData) {
    this.activeSlides = data;
  }

  selectTo(owlCar: any, moveNext: boolean) {
    this.curIndx = moveNext ? this.curIndx < this.timeline.length - 1 ? this.curIndx + 1 : this.timeline.length - 1 : this.curIndx > 0 ? this.curIndx - 1 : 0;
    owlCar.to(this.curIndx.toString());
    this.setActiveClass(this.timeline[this.curIndx].title);
  }
}
